import React from "react";
import { TransformacionSection } from "./sections/TransformacionSection";
import { BusquedaConversacionalSection } from "./sections/BusquedaConversacionalSection";
import { OptimizacionTecnicaSection } from "./sections/OptimizacionTecnicaSection";
import { AutoridadMarcaSection } from "./sections/AutoridadMarcaSection";
import { ContenidoSemanticoSection } from "./sections/ContenidoSemanticoSection";
import { SeoLocalSection } from "./sections/SeoLocalSection";
import { ChecklistSection } from "./sections/ChecklistSection";

export function ArticleContent() {
  return (
    <div className="prose prose-lg prose-invert max-w-none">
      <TransformacionSection />
      <BusquedaConversacionalSection />
      <OptimizacionTecnicaSection />
      <AutoridadMarcaSection />
      <ContenidoSemanticoSection />
      <SeoLocalSection />
      <ChecklistSection />
    </div>
  );
}
